import { MaterialReactTable } from "material-react-table"
import { taskColumns } from "./constants/taskColumns"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import { MenuItem } from '@mui/material';
import { customerIdData } from "./constants/constantFunctionsView";
import { useEffect, useState } from "react";
import { DetailedTaskView } from "./DetailedTaskView";
import CommonButton from "../Utils/CommonButton";
import { useDispatch, useSelector } from "react-redux";
import { fetchStatisticsOfTasks } from "../../slices/tasks/getstatistics/thunk";
import { Loader } from "../Utils/Loader";
import { fetchAllTasks } from "../../slices/tasks/getalltasks/thunk";
import { useColumnSettings } from "../Utils/useColumnSettings";
import { getView } from "../../slices/View/thunk";
import { fetchOperatorSpecificConfigurations } from "../../slices/OperatorManagement/GetConfigurationByOperatorId/thunk";
import { ToastContainer } from "react-toastify";
import BreadCrumb from "../Common/BreadCrumb";
import { hasPermission } from "../Utils/UtilityFunctions";

export const ViewTasks = ({ setView, setTaskDetails, view }) => {
    const rawPermissions = useSelector(
        (state) => state.permissions.permissionsMap
    );

    const permissionsMap = new Map(
        rawPermissions.map(([key, value]) => [key, new Set(value)])
    );
    const taskPermission = hasPermission(permissionsMap, "customer", "task");
    const viewPermission=hasPermission(permissionsMap, "miscellaneous", "view")
    const [viewTask, setViewTask] = useState(false)
    const [viewGlobalTaskDetails, setViewGlobalTaskDetails] = useState(false)
    const [loading, setLoading] = useState(false)
    const taskPath = customerIdData()
    const dispatch = useDispatch()
    const operatorId = localStorage.getItem("operatorId")
    const configData = useSelector((state) => state.OperatorSpecificConfig.OperatorSpecificConfiguration)

    useEffect(() => {
        if (taskPath === "tasks") {
            taskPermission && dispatch(fetchStatisticsOfTasks(setLoading))
            taskPermission && dispatch(fetchAllTasks(setLoading))
            dispatch(getView(setLoading));
        }
        else {
            taskPermission && dispatch(fetchAllTasks(setLoading, taskPath))
        }
        dispatch(fetchOperatorSpecificConfigurations(setLoading, operatorId))
    }, [dispatch])

    const statData = useSelector((state) => state.GetStatisticsOfTasks.getTaskStatistics)
    const taskData = useSelector((state) => state.GetAllTasks.getAllTasks)
    const operatorConfiguration = useSelector((state) => state?.GetOperatorSpecificConfiguration?.OperatorSpecificConfiguration)

    const isEIPEnabled = operatorConfiguration?.configurations?.EIP?.value?.Enabled?.value === true;

    function transformTaskTypes(tasks, isEIPEnabled) {
        if (!isEIPEnabled) return tasks;

        return tasks.map(task => {
            return {
                ...task,
                taskType: task.taskType === "PURCHASE_PLAN" ? "DEVICE_ACTIVATION" :
                    task.taskType === "UPDATE_CUSTOMER" ? "UPDATE_DEVICE" :
                        task.taskType === "CREATE_CUSTOMER" ? "CREATE_DEVICE" : task.taskType
            };
        });
    }
    const updatedTasks = transformTaskTypes(taskData, isEIPEnabled);

    const columns = taskColumns(taskPath, isEIPEnabled)

    const {
        settingsModalOpen,
        viewColumns,
        toggleSettingsModal,
        SettingsSidebar
    } = useColumnSettings('task', columns);
    return (
        <div className={taskPath === "tasks" && "page-content bg-white"}>
            {taskPath === "tasks" ? <BreadCrumb title={"Activity Logs"} pageTitle={"Customers"} /> : null}
            {taskPath === "tasks" ? <h5 className="p-2 px-4">{"Activity Logs List"}</h5> : null}

            {taskPath === "tasks" && <Row className="gy-4 ">
                <Col lg={12}>
                    {loading && <Loader />}
                    <ToastContainer position='top-center' />
                    <Row className="px-4">
                        <Col xxl={4}>
                            <div className="border rounded-1 px-3 py-2 my-2 bg-white">
                                <CardBody>
                                    <div className="d-flex  align-items-center py-3 p-2 pb-5">
                                        <div className="flex-column ">
                                            <h5 className="fw-bold rv-text-color ">Failed Tasks MTD</h5>
                                            <p className="mb-0 fs-1 fw-bold rv-text-color">{statData[0]?.failedTasksMTD}</p>
                                        </div>
                                    </div>
                                </CardBody>
                            </div>
                        </Col>
                        <Col xxl={4}>
                            <div className="border rounded-1 px-3 py-2 my-2 bg-white">
                                <CardBody>
                                    <div className="d-flex  align-items-center p-2 py-3 pb-5">
                                        <div className="flex-column ">
                                            <h5 className="rv-text-color fw-bold">Failed Internal Tasks MTD</h5>
                                            <p className="mb-0 fs-1 fw-bold rv-text-color">{statData[0]?.failedInternalTasksMTD}</p>
                                        </div>
                                    </div>
                                </CardBody>
                            </div>
                        </Col>
                        <Col xxl={4}>
                            <div className="border rounded-1 px-3 py-2 my-2 bg-white">
                                <CardBody>
                                    <div className="d-flex  align-items-center p-2 py-3 pb-5">
                                        <div className="flex-column ">
                                            <h5 className="rv-text-color fw-bold">Failed Provisional Tasks MTD</h5>
                                            <p className="mb-0 fs-1 fw-bold rv-text-color">{statData[0]?.failedProvisionalTasksMTD}</p>
                                        </div>
                                    </div>
                                </CardBody>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>}
            <Row className={taskPath === "tasks" ? "px-4" : "px-0"}>
                <Col lg={settingsModalOpen ? 10 : 12}>
                    <div className="border rounded-1 px-0 py-3 my-2 bg-white h-100">
                        {updatedTasks?.length > 0 ?
                            <div className="table-responsive ">
                                {((taskPath !== "tasks") || (taskPath === "tasks" && !viewTask)) && <MaterialReactTable data={updatedTasks} columns={taskPath === "tasks" ? columns.filter((column) => viewColumns?.includes(column.accessorKey || column.header)) : columns} enableDensityToggle={false}



                                    enableRowActions
                                    icons={{
                                        DragHandleIcon: () => <i className="ri-drag-move-fill" />,
                                    }}
                                    muiTableHeadCellProps={{
                                        sx: {
                                            fontFamily: "Inter,sans-serif"
                                        }
                                    }}
                                    muiTableBodyCellProps={{
                                        sx: {
                                            fontFamily: "Inter,sans-serif"
                                        }
                                    }}
                                    displayColumnDefOptions={{
                                        'mrt-row-actions': {
                                            header: '',
                                            enableHiding: true
                                        },
                                    }}
                                    initialState={{
                                        columnVisibility: {
                                            'taskId': false,
                                        },
                                    }}
                                    enableColumnActions={true}
                                    renderTopToolbar={false}
                                    renderTopToolbarCustomActions={({ }) => (
                                        <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between w-100">
                                            {taskPath === "tasks" && viewPermission && viewPermission?.has("view") && <><div className="d-flex flex-column flex-md-row">
                                            </div>                                          
                                                <div className="d-flex align-items-center">
                                                    <div color="secondary" className="btn-icon me-2 cursor-img" onClick={toggleSettingsModal}>
                                                        <i className="ri-settings-2-line fs-4"></i>
                                                    </div>
                                                </div></>}
                                        </div>
                                    )}
                                    renderRowActionMenuItems={({ closeMenu, row }) =>
                                        [
                                            <MenuItem key="view" onClick={() => {
                                                if (taskPath !== "tasks") {
                                                    setTaskDetails(row.original)
                                                    setView(true)
                                                }
                                                else {
                                                    setViewGlobalTaskDetails(row.original)
                                                    setViewTask(true)
                                                }
                                                closeMenu()

                                            }}>
                                                <i className="ri-eye-line me-2"></i>
                                                View
                                            </MenuItem>
                                        ]
                                    }
                                />}
                            </div>
                            : (
                                <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '200px' }}>
                                    No record to display
                                </div>
                            )}
                        {viewTask && <DetailedTaskView configurations={configData} taskDetails={viewGlobalTaskDetails} taskPath={taskPath} />}

                    </div>
                </Col>
                {SettingsSidebar()}
            </Row>
            {(viewTask) && <Row lg={6} className="mt-5 ms-3  mb-4">
                <div className="d-flex gap-2 ">
                    <div className="me-auto">
                        <CommonButton
                            outline={true}
                            className={
                                "btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                            }
                            color={"main-color"}
                            type={"reset"}
                            buttonAction={() => {
                                if (viewTask) {
                                    setViewTask(false)
                                }
                            }}
                            buttonText={"Back"}
                            icon={
                                <i
                                    className="ri-play-mini-fill label-icon align-middle fs-16 me-2"
                                    style={{ transform: "scaleX(-1)", borderLeft: "1px solid" }}
                                ></i>
                            }
                            btnTxtClsName={"px-2 ps-3 ms-2 me-1"}
                        />
                    </div>
                    {/* <CommonButton color={"main-color"} type={'submit'} buttonAction={() => {
                        if (viewTask) {
                            setViewTask(false)
                        }
                    }} buttonText={"Back"} /> */}
                </div>
            </Row>}
        </div>
    )
}